"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.progress.complete': '完成',
    'onboarding.progress.steps': '步骤',
};
